type ArticleKickerProps = {
  className?: string;
  kicker?: string;
};

export default function ArticleKicker({
  className,
  kicker,
}: ArticleKickerProps): React.ReactElement {
  return (
    <>
      {kicker ? (
        <div className={className} data-testid="article-kicker-component">
          {kicker}
        </div>
      ) : null}
    </>
  );
}
